import { jsx as _jsx } from "react/jsx-runtime";
import { Tag } from '@dossierhq/design';
export function TypeDraftStatusTag({ status }) {
    const { color, text } = {
        new: { color: 'draft', text: 'New' },
        changed: { color: 'modified', text: 'Changed' },
    }[status];
    return _jsx(Tag, { color: color, children: text });
}
//# sourceMappingURL=TypeDraftStatusTag.js.map